let provider;
export const initLocalStore = (clientProvider) => {
    provider = clientProvider;
};
export const getItem = async (key) => {
    return provider.getItem(key);
};
export const setItem = async (key, value) => {
    return provider.setItem(key, value);
};
export const removeItem = async (key) => {
    return provider.removeItem(key);
};
//# sourceMappingURL=local-store.js.map